import styled from "styled-components";

const Wrapper = styled.header`
    transition : 0.3s;
    
    box-sizing : border-box;
    @media screen and (max-width: 1000px) {
        padding : 0 10px;
    }
    height : 90px;
    position : fixed;
    top : 0;
    left : 0;
    width : 100%;
    background : #fff;
    box-shadow : 0 1px 1px rgba(0,0,0,0.2);
    z-index : 10;

    .breadcrumItems{
        padding : 5px 50px;
        border-top : solid thin #ccc;
    }

    &.open{
        height : 600px;
        background : rgba(255,255,255,0.9);
        .hamburger{
            .line2{
                display : none;
            }
            .line1{
                transform : rotate(-45deg);
            }
            .line3{
                transform : rotate(45deg);
            }
        }
    }

    .innerHeader{
        padding : 0 30px;
        box-sizing : border-box;
        display : flex;
        align-items : center;
        width : 100%;
        .logo {
            cursor: pointer;
            text-align: left;
            width : calc(186px);
            img {
                height: 42px;
                display: block;
            }
        }
        .hamburger{
            cursor : pointer; 
            background : none;
            width : 90px;
            height : 90px;
            padding : 0;
            justify-content: center;
            align-items: center;
            display: flex;
            border : none;
            
            .inner{
                display : flex;
                flex-flow : column;
                align-items: center;
                justify-content: space-between;
                width : 1.5rem;
                height : 20px;
                >div{
                    width : 100%;
                    height : 3px;
                    background : #000;
                    border-radius : 5px;
                    transform-origin: right;
                    transition : 0.3s;
                }
            }

            
        }

        input[type=search]{
            padding : 10px;
            flex : 1;
            border-radius : 30px;
            border : solid thin #ccc;
            max-width : 350px;
            margin-right : 10px;
        }

        .spacer{
            flex : 1;
        }

        .buttons input,button{
            width : 148px;
            height : 1.5rem;
        }

        input[type=button],button{
            background-color : transparent;
            border : none;
            cursor : pointer;
            background-repeat : no-repeat;
            background-position : center right;
        }

        .user{
            height : 90px;
            min-width : 90px;
            border : solid 20px #fff !important;
            border-radius : 48px;
            background-color : #051C2C !important;
            font-size : 1.2rem;
            color : #fff;
            position : relative;
            &:hover+.user-overlay{
                display : block;
            }
        }

        .user-overlay{
            &:hover{
                display : block;
            }
            display: none;
            position: absolute;
            background: #fff;
            border : solid thin #ccc;
            top : 90px;
            right: 10px;
            input[type=button]{
                width : 100%;
                text-align : left;
                margin : 0;
                padding : 0;
                font-size : 16px;
                width : 180px;
                padding : 10px 20px;
                display : block;
                border-radius : 10px;
                box-sizing: content-box;
                &:hover{
                    background : #f2f2f2;
                }
            }
            ul{
                padding : 0;
                margin : 0;
                
                li{
                    list-style : none;
                    text-align : left;
                    padding : 0;
                    a{
                        text-decoration : none;
                        width : 180px;
                        color : #000;
                        font-size : 16px;
                        padding : 10px 20px;
                        display : block;
                        border-radius : 10px;
                        &:hover{
                            background : #f2f2f2;
                        }
                    }
                }
            }
        }

    }

    a{
        color : #6c6c6c;
        text-transform: capitalize;
        &:hover{
            color : #2251cc;
        }
        &:last-of-type{
            color : #000;
        }
    }

    
`

export default Wrapper